export var NameNameType = /* @__PURE__ */ ((NameNameType2) => {
  NameNameType2["Business"] = "Business";
  NameNameType2["Trade"] = "Trade";
  NameNameType2["Legal"] = "Legal";
  NameNameType2["Person"] = "Person";
  NameNameType2["Other"] = "Other";
  return NameNameType2;
})(NameNameType || {});
